export default __webpack_public_path__ + "09d6daa9b90ddf42f70437e11027f9a7.jpg";